var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"comparator-vue",class:{
    'comparator-vue-view': !_vm.compare,
    'comparator-vue-compare': _vm.compare,
    'comparator-vue-other': _vm.other !== undefined,
    'comparator-vue-hidden': _vm.hidden,
  }},[_vm._t("default",null,{"value":_vm.value,"other":_vm.other,"index":_vm.index,"view":!_vm.compare || undefined,"compare":_vm.compare || undefined,"listeners":_vm.computedListeners,"attrs":_vm.computedAttrs,"vuedata":_vm.vuedata})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }